/**
 * Series colors aligned with smart-web / smart-api productData.color.enum
 * for Lion Pro telemetry keys (and common aliases).
 *
 * Source: apps/smart-api/src/product-data/enums/productData.color.enum.ts
 */

/** Fallback palette when a key has no smart-web mapping. */
export const SERIES_COLOR_PALETTE = [
  '#2563EB', // blue
  '#059669', // emerald
  '#D97706', // amber
  '#DC2626', // red
  '#7C3AED', // violet
  '#0891B2', // cyan
  '#EA580C', // orange
  '#4F46E5', // indigo
  '#DB2777', // pink
  '#65A30D', // lime
] as const

/** Hex colors derived from smart-web `main` RGB values. */
export const SMART_WEB_SERIES_COLORS: Record<string, string> = {
  // Solar / production — pink
  pv_w: '#FF5181',
  pv_total_p: '#FF5181',
  pv_dc_p: '#1670CA',
  dc_pv_w: '#1670CA', // Dc_Solar (dodger blue)
  dc_p: '#1670CA',
  ac_pv_w: '#A52A2A', // Ac_Solar
  solar: '#FF5181',
  solar_power: '#FF5181',

  // Load / consumption — purple
  load_w: '#9370DB', // Load_Power
  load_p: '#9370DB',
  consumption: '#CF51FF',
  acc_w: '#CF51FF',

  // Battery power — gold (Battery day series)
  bat_w: '#FFD052',
  pdu_p: '#FFD052',
  battery: '#FFD052',
  battery_power: '#9B111E', // Battery_Power (cabinet)

  // SoC — green
  bat_soc: '#30BF78',
  pdu_soc: '#30BF78',
  soc: '#30BF78',
  system_soc: '#30BF78',

  // Grid — blue
  grid_w: '#5081FF',
  grid_p: '#5081FF',
  grid: '#5081FF',
  grid_power: '#5081FF',
  sold_to_grid: '#5081FF',

  // Generator — coral/orange
  gen_w: '#FF7851',
  gen_p: '#FF7851',
  generator: '#FF7851',
  generator_power: '#FF7F50',
}

export function colorForTelemetryKey(key: string): string | undefined {
  const direct = SMART_WEB_SERIES_COLORS[key]
  if (direct) return direct
  const lower = key.toLowerCase()
  return SMART_WEB_SERIES_COLORS[lower]
}

export function resolveSeriesColor(key: string, fallbackIndex: number): string {
  return colorForTelemetryKey(key) ?? SERIES_COLOR_PALETTE[fallbackIndex % SERIES_COLOR_PALETTE.length]
}
